<bz-dialog-layout [heading]="'Export Payroll' | translate" [dismissible]="true">

  <div bzDialogContent class="layout-column timecard-dialog-body" appBringozIdGenerator="exportPayrollDialog">
    <div class="br-body-1">{{ 'TIMEKEEPING_EXPORT_PAYROLL_DISCLAIMER' | translate }}</div>

    <bz-expansion-panel appBringozIdGenerator="advancedPanel" [heading]="'Advanced' | translate">
      <div class="layout-column timecard-dialog-body">
        <div class="timecard-dialog-row">
          <bz-checkbox appBringozIdGenerator="completeApprovedCheckbox"
                       [checked]="completeApproved()"
                       (checkedChange)="completeApproved.set($event)">
            {{ 'Finalize all Approved Timecards' | translate }}
          </bz-checkbox>
          <bz-tooltip placement="top" [content]="'TIMEKEEPING_EXPORT_PAYROLL_COMPLETE_APPROVED_TOOLTIP' | translate">
            <bz-icon size="sm" [icon]="icons.info"></bz-icon>
          </bz-tooltip>
        </div>

        <div class="timecard-dialog-row">
          <bz-checkbox appBringozIdGenerator="archiveNotApprovedCheckbox"
                       [checked]="archiveNotApproved()"
                       (checkedChange)="archiveNotApproved.set($event)">
            {{ 'Archive all not Approved Timecards' | translate }}
          </bz-checkbox>
          <bz-tooltip placement="top" [content]="'TIMEKEEPING_EXPORT_PAYROLL_ARCHIVE_NOT_APPROVED_TOOLTIP' | translate">
            <bz-icon size="sm" [icon]="icons.info"></bz-icon>
          </bz-tooltip>
        </div>
      </div>
    </bz-expansion-panel>
  </div>

  <div bzDialogActions>
    <bz-button variant="tertiary" appBringozIdGenerator="cancelBtn" (clicked)="onCancel()">
      {{ 'Cancel' | translate }}
    </bz-button>
    <bz-button tone="secondary" appBringozIdGenerator="confirmBtn" (clicked)="onConfirm()">
      {{ 'Confirm' | translate }}
    </bz-button>
  </div>

</bz-dialog-layout>
